import { LoaderRoot } from "./Loader.styles";
import { Box } from "@mui/material";

export const Loader = (props) => {
  const { type, show } = props;

  return <LoaderRoot sx={{ opacity: show ? 1 : 0 }} />;
};

Loader.defaultProps = {
  show: true,
};
